import { SET_SEARCH_INFO, SearchState } from './constant';

export function setSearchInfo(payload: SearchState) {
  return {
    type: SET_SEARCH_INFO,
    payload,
  };
}
